<template>
    <AppLayout>
         <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">

                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Termos de uso
                </h2>
            </div>
        </template>
        <div class="py-12 items-center flex justify-center w-full">
            <main
                class="bg-white shadow-card pt-5 pb-7 pl-7 pr-8 rounded font-medium" v-html="term.terms"
            >

            </main>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import { defineComponent } from "vue";
export default defineComponent({
    data() {
        return {
            name: "TermsCrypto",
            
        };
    },
    props: ["term"],
    components: {
        AppLayout
    }
});
</script>

<style scoped >
main {
   width: 50vw;
}
</style>
